import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { Button } from '@bikemap/components/Button'
import { MinimalButton } from '@bikemap/components/MinimalButton'

import styles from './SpamWidget.module.scss'
import { gettext } from '@bikemap/js/services'
import { route } from '@bikemap/js/api'

/**
 * @param {*} props
 * @param {number} props.routeId
 * @param {() => void} props.onMarkSpam
 * @param {() => void} props.onMarkNotSpam
 * @param {() => void} props.onMarkAllOfUserAsSpam
 * @param {() => void} props.onDeleteSpamUser
 * @param {() => void} props.onShowSpam
 */
export const SpamWidget = ({
    routeId,
    onMarkSpam,
    onMarkNotSpam,
    onMarkAllOfUserAsSpam,
    onDeleteSpamUser,
    onShowSpam,
}) => {
    const [isSpam, setIsSpam] = useState()
    const [isReviewed, setIsReviewed] = useState()

    useEffect(() => {
        route.readSpamStatus(routeId).then((spamStatus) => {
            setIsSpam(spamStatus.isSpam)
            setIsReviewed(spamStatus.isReviewed)
        })
    }, [])

    const introductionLabel = gettext('This route is')
    const descriptionLabel = isSpam
        ? isReviewed
            ? gettext('confirmed spam')
            : gettext('potential spam')
        : gettext('not spam')
    const markAsSpamLabel = gettext('Mark as spam')
    const markAsNotSpamLabel = gettext('Mark as not spam')
    const confirmLabel = gettext('Confirm spam')
    const markAllOfUserAsSpamLabel = gettext('Mark all routes of this user as spam')
    const deleteSpamUserLabel = gettext('Delete user')
    const showMeSpamLabel = gettext('Show me potential spam')

    const handleMarkSpam = () => {
        onMarkSpam()
        setIsSpam(true)
        setIsReviewed(true)
    }

    const handleMarkNotSpam = () => {
        onMarkNotSpam()
        setIsSpam(false)
        setIsReviewed(true)
    }

    return (
        <div>
            <div className={cx(styles.container, { [styles.spam]: isSpam })}>
                <div>{introductionLabel} <strong>{descriptionLabel}</strong>.</div>
                <div className={styles.buttons}>
                    {isSpam
                        ? isReviewed
                            ? (
                                <Button size='action' variant='success' onClick={handleMarkNotSpam}>
                                    {markAsNotSpamLabel}
                                </Button>
                            )
                            : (
                                <>
                                    <Button size='action' variant='danger' onClick={handleMarkSpam}>
                                        {confirmLabel}
                                    </Button>
                                    <Button size='action' variant='success' onClick={handleMarkNotSpam}>
                                        {markAsNotSpamLabel}
                                    </Button>
                                </>
                            )
                        : (
                            <Button size='action' variant='danger' onClick={handleMarkSpam}>
                                {markAsSpamLabel}
                            </Button>
                        )
                    }
                </div>
            </div>
            <div className={styles.additional}>
                <MinimalButton onClick={onShowSpam}>
                    {showMeSpamLabel}
                </MinimalButton>
                <MinimalButton variant='danger' onClick={onMarkAllOfUserAsSpam}>
                    {markAllOfUserAsSpamLabel}
                </MinimalButton>
                <MinimalButton variant='danger' onClick={onDeleteSpamUser}>
                    {deleteSpamUserLabel}
                </MinimalButton>
            </div>
        </div>
    )
}
